
  import { Vue, Component, Prop } from "vue-property-decorator";
  import TotalCounter from "@/components/common/TotalCounter.vue";

  @Component({
    components: {
      TotalCounter,
    },
  })
  export default class ActionPanel extends Vue {
    @Prop({ type: Number, required: true }) readonly total!: number;
     @Prop({ type: String, required: false }) readonly pageName!: string;
  }
